import axios from "axios";
import React, { useEffect, useState } from "react";
import StickyTable from "../../components/common/StickyTable";
import { TESTIMONIAL_LIST, TESTIMONIAL_DELETE, USER_LIST_DROPDOWN } from "../../routes/routes";
import { PAGINATE, TESTIMONIAL_DELETED } from "../../constant/constant";
import {
  NoDataFound,
  Pagination,
  checkEmptyOrNull,
  hasRole,
} from "../../components/Utils";
import { usePermission } from "../../hooks/usePermission";
import Loader from "../../components/common/Loader"; // Import the loader component
import { Modal } from "react-bootstrap";
import ModalImage from "react-modal-image";
import Select from "react-select";
import "flatpickr/dist/themes/material_red.css";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";

const TestimonialsList = () => {
  // ## State Variable Declaration
  const [data, setData] = useState([]);
  const [paginator, setPaginator] = useState({});
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const [detailData, setDetailData] = useState({});
  const [detailsModal, setDetailModal] = useState(false);
  const [confirmation, setConfirmation] = useState({});
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [filter, setFilter] = useState([]);
  const [userOptions, setUserOptions] = useState({});

  const auth_user = JSON.parse(localStorage.getItem("user"));
  const isSuperAdmin = auth_user?.user_type === 1 ? 1 : 0;
  const isRegionAdmin = auth_user?.user_type === 2 ? 1 : 0;
  const isChapterAdmin = auth_user?.user_type === 3 ? 1 : 0;
  const { hasPermission } = usePermission();

  const HandleDelete = async (id) => {
    try {
      axios.delete(TESTIMONIAL_DELETE + id).then((res) => {
        if (res.status === 200 && res.data.success) {
          toast.success(TESTIMONIAL_DELETED);
          setRefresh((prev) => !prev);
        }
      });
    } catch (error) {
      console.error("Error deleting testimonial:", error);
    }
  };

  useEffect(() => {
    setLoading(true);
    axios
      .get(TESTIMONIAL_LIST, {
        params: {
          type: PAGINATE,
          page: page,
          perPage: perPage,
          isAdmin: 1,
          ...filter,
        },
      })
      .then((response) => {
        if (response.status === 200 && response.data.success) {
          setData(response.data.data.testimonials);
          setPaginator({
            prev: response.data.data.prev_page_url != null,
            next: response.data.data.next_page_url != null,
            total: response.data.data.total,
            current: response.data.data.current_page,
            last: response.data.data.last_page,
          });
        }
      })
      .finally(() => {
        setLoading(false); // Set loading to false after data is fetched
      });

    const fetchData = async () => {
      try {
        // Fetch user data
        const userResponse = await axios.get(USER_LIST_DROPDOWN, {
          params: {
            ...filter,
            exclude_other_region_chapter_users: 1,
          },
        });
        const fetchedUserOptions = userResponse.data.data;
        setUserOptions(fetchedUserOptions);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, [page, filter, perPage, refresh]);

  return (
    <div className="content-wrapper">
      <div className="container-fluid p-0 mt-0 mb-3">
        <div className="col-lg-12">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h5 className="page-title">Testimonials List</h5>
              <ol className="breadcrumb">
                <li>
                  <div className="breadcrumb_f">
                    <div>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="50"
                        height="50"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="#212b39"
                        strokeWidth="1"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                      </svg>
                    </div>
                    <div>
                      <Link to={"/dashboard"}>
                        <span>Dashboard</span>
                      </Link>
                    </div>
                  </div>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="50"
                    height="50"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="#212b39"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M9 18l6-6-6-6" />
                  </svg>
                </li>
                <li>
                  <span className="active_breadcrumb">Testimonials List</span>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div className="flex-grow-1">
        <div className="card icard sticky-table-card">
          {/* <div className="card-header">
            <h5>Testimonials List</h5>
          </div> */}
          <div className="container-fluid f_containter">
            <div className="row mb-4 gx-3">
              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="from_user_id">
                    From User
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="from_user_id"
                    isClearable
                    options={userOptions}
                    onChange={(selected) =>
                      setFilter({ ...filter, from_user_id: selected?.value })
                    }
                    placeholder="From User"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="to_user_id">
                    To User
                  </label>
                  <Select
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                    }}
                    name="to_user_id"
                    isClearable
                    options={userOptions}
                    onChange={(selected) =>
                      setFilter({ ...filter, to_user_id: selected?.value })
                    }
                    placeholder="To User"
                  />
                </div>
              </div>
              <div className="col-md-3">
                <div className="mb-3">
                  <label className="form-label" htmlFor="search">
                    Search
                  </label>
                  <input
                    type="text"
                    className="form-control hide-arrow"
                    id="search"
                    placeholder="Search by Feedback"
                    onChange={(e) =>
                      setFilter({ ...filter, search: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
          <StickyTable refreshDeps={[data, loading]}><table className="table table-striped itable">
              <thead>
                <tr>
                  <th>Sl. No.</th>
                  <th>From User</th>
                  <th>To User</th>
                  <th width="300px">Feedback</th>
                  <th>Created At</th>
                  <th style={{ textAlign: "center", width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody className="table-border-bottom-0">
                {loading ? (
                  <Loader loading={loading} colspan="6" />
                ) : data.length > 0 ? (
                  data.map((testimonial, i) => (
                    <tr key={i}>
                      <td>{testimonial?.sno}</td>
                      <td>
                        <span className="table_img pr-2">
                          <img
                            src={testimonial?.from_profile_image}
                            alt="icon"
                          />
                        </span>
                        {testimonial?.from_user_name}
                      </td>
                      <td>
                        <span className="table_img pr-2">
                          <img src={testimonial?.to_profile_image} alt="icon" />
                        </span>
                        {testimonial?.to_user_name}
                      </td>
                      <td className="word-wrap">{testimonial?.remarks}</td>
                      <td>{testimonial?.created_at}</td>
                      <td style={{ textAlign: "center" }}>
                        {hasPermission("testimonials-list") && (
                          <button
                            className="badge bg-label-info me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="View"
                            data-bs-original-title="View"
                            onClick={() => {
                              setDetailModal(true);
                              setDetailData(testimonial);
                            }}
                          >
                            <i className="bx bx-show"></i>
                          </button>
                        )}
                        {hasPermission("testimonials-edit") && (
                          <Link to={`/testimonials/${testimonial.id}/edit`}>
                            <button
                              className="badge bg-label-success me-1 border-0"
                              data-bs-toggle="tooltip"
                              data-bs-offset="0,4"
                              data-bs-placement="top"
                              data-bs-html="true"
                              title="Edit"
                              data-bs-original-title="Edit"
                            >
                              <i className="bx bx-pencil"></i>
                            </button>
                          </Link>
                        )}
                        {hasPermission("testimonials-delete") && (
                          <button
                            onClick={() => {
                              setConfirmationModal(true);
                              setConfirmation({
                                message: "Are you sure, you want to delete?",
                                fn: () => HandleDelete(testimonial?.id),
                              });
                            }}
                            className="badge bg-label-danger me-1 border-0"
                            data-bs-toggle="tooltip"
                            data-bs-offset="0,4"
                            data-bs-placement="top"
                            data-bs-html="true"
                            title="Delete"
                            data-bs-original-title="Delete"
                          >
                            <i className="bx bx-trash"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  ))
                ) : (
                  <NoDataFound colspan="6" message="No Data Found" />
                )}
              </tbody>
            </table>
          </StickyTable>
          {/* Pagination Component */}
          {data.length > 0 && (
            <Pagination
              paginator={paginator}
              page={(no) => setPage(no)}
              perPage={perPage}
              setPerPage={setPerPage}
            />
          )}
        </div>
      </div>

      <Modal
        show={detailsModal}
        size="l"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setDetailModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="modal_title1"
          >
            Testimonials Details
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="card-body py-0">
            <div className="row">
              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">Date</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.created_at)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">From User</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.from_user_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-6">
                <div className="mb-4">
                  <label className="form-label m-0">To User</label>

                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.to_user_name)}
                  </span>
                </div>
              </div>

              <div className="col-md-12">
                <div className="mb-4">
                  <label className="form-label m-0">Feedback</label>
                  <span className="d-block font-weight-600">
                    {checkEmptyOrNull(detailData.remarks)}
                  </span>
                </div>
              </div>

              {/* Images Section */}
              {detailData.images && detailData.images.length > 0 && (
                <div className="col-md-12">
                  <div className="mb-4">
                    <label className="form-label m-0">Images</label>
                    <div className="row mt-2">
                      {detailData.images.map((image, index) => (
                        <div key={index} className="col-md-3 mb-2">
                          <ModalImage
                            small={image}
                            large={image}
                            alt={`Testimonial image ${index + 1}`}
                            showRotate
                            hideDownload={true}
                            className="img-fluid"
                            style={{ maxHeight: "200px", objectFit: "cover" }}
                          />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-secondary ibutton"
            data-bs-dismiss="modal"
            onClick={() => setDetailModal(false)}
          >
            Close
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={confirmationModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        onHide={() => setConfirmationModal(false)}
        backdrop="static"
      >
        <Modal.Header closeButton className="no-border"></Modal.Header>
        <Modal.Body className="idel_popup">
          <div className="icon_holder">
            <div className="pop_del_icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#1A4331"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <polyline points="3 6 5 6 21 6"></polyline>
                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
                <line x1="10" y1="11" x2="10" y2="17"></line>
                <line x1="14" y1="11" x2="14" y2="17"></line>
              </svg>
            </div>
          </div>
          <h6 className="text-center modal_title">{confirmation?.message}</h6>
          <div className="text-center">
            <button
              onClick={() => {
                setConfirmationModal(false);
                setConfirmation({});
              }}
              className="btn btn-danger btn-sm me-2 iclose_btn"
            >
              No
            </button>
            <button
              onClick={() => {
                setConfirmationModal(false);
                confirmation?.fn?.();
                setConfirmation({});
              }}
              className="btn btn-success btn-sm isubmit_button"
            >
              Yes
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default TestimonialsList;
